<template lang="pug">
.detail.scrollable.h-100
  .mx-4.my-2.px-3
    .d-flex.align-items-center.pt-4.pb-3
      CustomerCompactDetailHeader(:data='customer')
      div.ml-auto.mr-4
        .d-flex
          .text-large.mr-3
            | {{ deliveryType }}
          CustomStatusBadge(
            :status='deliveryStatus'
            type='SHIPMENT_STATUS'
          )
        .text-small(v-if='deliveryTypeExtra')
          | {{ deliveryTypeExtra }}

        //- .text-small.mt-3
        //-   | เลขที่ใบสั่งซื้อจากลูกค้า
        //-   | {{ backOrders.customer_po_no ? backOrders.customer_po_no : '-' }}
        //-   //- span.ml-1(
        //-   //-   v-for='order in backOrders'
        //-   //-   v-html='`${order.customer_po_no},`'
        //-   //- )

  .sticky-top.bg-white
    .d-flex.px-4.pt-2.pb-3
      .text-large รายการสินค้า
      LoadingIndicator.ml-2(v-if='isLoading')
    hr.m-0

  template(v-if='backOrders')
    .px-4.pt-2
      //- div {{ JSON.stringify(backOrders) }}
      CustomTable(
        :columns='tableColumns'
        :data='tableData'
        :itemClickable='false'
      )
    hr.m-0
    .sticky-bottom.bg-white.d-flex.mx-3.px-4.py-4
      //- .d-flex
      //-   div หมายเหตุ
      //-   ol
      //-     li ...
      //-     li ...
      .d-flex.flex-column.align-items-end.ml-auto
        .text-medium
          span.mr-3 รวมมูลค่าทั้งสิ้น
          span.ml-4 {{ total | currency }}
        .text-xlarge.mt-1
          span.mr-3 รวมค่าคอมมิชชั่นที่ได้รับ
          span.ml-4 {{ totalCommission | currency }}

</template>

<script>
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
    backOrders: {
      default: () => ({}),
    },
  },
  computed: {
    // formattedDate() {
    //   return this.$moment(this.backOrder.date).format('D MMMM YYYY');
    // },
    // formattedTime() {
    //   return this.$moment(this.backOrder.time).format('HH:mm');
    // },
    deliveryStatus() {
      return this.backOrders[0].shipmentStatus;
    },
    deliveryType() {
      const { ship_type: shipType } = this.backOrders[0];
      return this.$dictionary.deliveryType[shipType];
    },
    deliveryTypeExtra() {
      return this.backOrders[0].ship_to;
    },
  },
  watch: {
    backOrders() {
      this.backOrderUpdated();
      // this.tableData = newVal.products ? newVal.products : [];
    },
  },
  mounted() {
    if (this.backOrders) {
      this.backOrderUpdated();
    }
  },
  data: () => ({
    tableColumns: {
      productId: {
        title: 'รหัสสินค้า',
      },
      productName: {
        title: 'ชื่อสินค้า',
        align: 'left',
      },
      amount: {
        title: 'จำนวนสินค้า',
        align: 'right',
      },
      productPrice: {
        title: 'ราคาขาย',
        align: 'right',
        type: Number,
        computed(row) {
          return Number(row.product.price) / Number(row.product.amount);
        },
      },
      totalPrice: {
        title: 'ยอดรวม',
        align: 'right',
        type: Number,
        computed(row) {
          return row.product.price;
        },
      },
    },

    tableData: {},
    isLoading: false,

    total: 0,
    totalCommission: 0,
  }),
  // mounted() {
  //   this.loadData();
  // },
  methods: {
    // async loadData() {
    //   this.isLoading = true;

    //   const res = await this.$api.history.backOrderItems(this.backOrder.entryNo);
    //   if (res.status === 200) {
    //     this.tableData = res.data.data;
    //   }

    //   this.isLoading = false;
    // },
    backOrderUpdated() {
      this.tableData = this.backOrders ? this.backOrders : [];

      let total = 0;
      let totalCommission = 0;
      for (let i = 0; i < this.backOrders.length; i += 1) {
        const PROD = this.backOrders[i];
        // console.log(PROD);
        total += (Number(PROD.productPrice * PROD.amount));
        totalCommission += (Number(PROD.product.commission));
      }

      this.total = total;
      this.totalCommission = totalCommission;

      // console.log('updated!!');
      // console.log(`${total} ${totalCommission}`);
    },
  },
  components: {
    CustomerCompactDetailHeader,
  },
};
</script>

<style lang="scss">
// .detail {}
</style>
